export default __webpack_public_path__ + "src/assets/downloads/MineSpace_User_Guide_2026.pdf";